import { FormFieldIcon } from "@insite/mobius/FormField";
import getColor from "@insite/mobius/utilities/getColor";
import { quickOrderStyles as styles } from "@solveindustrial/Overrides/Widgets/Basic/QuickOrder";
import { commonInputIcons } from "@solveindustrial/Utilities/styleguide";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.quickOrderContainer = {
    ...styles.quickOrderContainer,
    gap: 0,
    offsetCss: css`
        background-color: ${getColor(colorStrings.primaryMain)};
        border-radius: 4px;
        padding: 20px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        gap: 20px;

        ${mediaQueriesBP.minMD} {
            padding: 40px;
        }
    `,
};

styles.container = {
    ...styles.container,
    offsetCss: css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;

        ${mediaQueriesBP.minMD} {
            flex-direction: row;
            align-items: center;
        }
    `,
};

styles.titleText = {
    ...styles.titleText,
    variant: "h2",
    color: colorStrings.commonGlobalWhite,
};

styles.linksGridItem = {
    ...styles.linksGridItem,

    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        gap: 24px;

        ${mediaQueriesBP.minMD} {
            flex-direction: row;
            justify-content: flex-end;
        }
    `,
};

styles.orderMultipleItemsLink = {
    color: colorStrings.commonGlobalWhite,
    typographyProps: {
        size: 18,
        lineHeight: "24px",
    },
    mergeCss: true,
};

styles.orderUploadLink = {
    color: colorStrings.commonGlobalWhite,
    typographyProps: {
        size: 18,
        lineHeight: "24px",
    },
    mergeCss: true,
};

styles.productSelector = {
    ...styles.productSelector,
    container: {
        css: css`
            label {
                color: ${getColor(colorStrings.commonGlobalWhite)};
            }
        `,
    },
    searchGridItem: {
        width: [12, 12, 5, 6, 6],

        css: css`
            position: relative;
        `,
    },

    searchDynamicDropdown: {
        ...styles.productSelector?.searchDynamicDropdown,
        cssOverrides: {
            list: css`
                top: 50px;
            `,
            selectedText: css`
                line-height: 50px;
                padding: 0 25px 0 10px;
            `,
            dropdownWrapper: css`
                input,
                input:not(.react-datetime-picker__inputGroup__input) {
                    ${mediaQueriesBP.maxMD} {
                        height: 50px !important;
                        min-height: 50px !important;
                        line-height: 50px !important;
                    }
                }
                ${FormFieldIcon} {
                    width: 50px !important;
                    height: 50px !important;
                    min-height: 50px !important;
                }
            `,
        },
    },

    qtyGridItem: {
        ...styles.productSelector?.qtyGridItem,
        width: [12, 12, 2, 2, 2],
        css: css`
            input,
            input:not(.react-datetime-picker__inputGroup__input) {
                ${mediaQueriesBP.maxMD} {
                    height: 50px !important;
                    min-height: 50px !important;
                    line-height: 50px !important;
                }
            }
            ${FormFieldIcon} {
                width: 50px !important;
                height: 50px !important;
                min-height: 50px !important;
            }
        `,
    },
    unitOfMeasureGridItem: {
        width: [12, 12, 2, 2, 2],
    },
    buttonGridItem: {
        width: [12, 12, 3, 2, 2],
    },
    clearIcon: {
        css: css`
            ${commonInputIcons};
            height: 50px;
            min-height: 50px;
            ${mediaQueriesBP.minMD} {
                right: 30px;
                top: 47px;
            }
        `,
    },
    selectButton: {
        ...styles.productSelector?.selectButton,
        variant: "tertiary",
    },

    unitOfMeasureSelect: {
        css: css`
            ${mediaQueriesBP.maxMD} {
                height: 50px !important;
                min-height: 50px !important;
                line-height: 50px !important;
            }

            ${FormFieldIcon} {
                width: 50px !important;
                height: 50px !important;
                min-height: 50px !important;
            }
        `,
        iconProps: {
            css: css`
                width: 50px !important;
                height: 50px !important;
                min-height: 50px !important;
            `,
        },
    },
};
